import React, { FC } from 'react';
import Component from './styles';
import { Props } from './types';

const Status: FC<Props> = ({ status, ...props }) => {
  return <Component status={status} {...props} />;
};

export default Status;
